import {
	observer
} from 'mobx-react';
import {
	Dialog,
	Form
} from '../../public/coms/index.js';
import Link from './Link.js';
import '../../style/financeExpand.less';

@observer
export default class VerifyResourceID extends React.Component {
	render() {
		const {
			store
		} = this.props, {
			dialogStore,
			formStore,
			isNeedSecondPwdSet,
		} = store;
		
		return (
			<Dialog ecId={`${this && this.props && this.props.ecId || ''}_Dialog@8k1f82`} store={dialogStore}>
				<div className='hrm-resource-id-verify-form'>
					<Form ecId={`${this && this.props && this.props.ecId || ''}_Form@fti2sx`} store={formStore} />
				</div>
				{
					isNeedSecondPwdSet && <Link ecId={`${this && this.props && this.props.ecId || ''}_Link@isbxrq`} />
				}
			</Dialog>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/financeExpand/VerifyResourceID.js